// extracted by mini-css-extract-plugin
export default {"banner":"offlineBanner_banner__-V4eP","icon":"offlineBanner_icon__Ds0XX","text":"offlineBanner_text__R1UiO"};